const initialState = {
  regionsList: [],
};

export const regionsReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "regions")
    return action.execute(state);
  return state;
};
